<template>
  <div class="navbar">
    <div class="navbar-inset">
      <div class="logo">
        <img :src="logo" />
      </div>
      <div style="width:700px;display: inline-flex;text-align: center;margin:0 auto">
        <div class="menu-list">
          <div
            class="menu"
            :class="activityMenu === index ? 'activited' : ''"
            v-for="(n, index) in menuList"
            @click="changeView(index)"
            :key="index"
          >
            {{ n.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { logo } from '../../images/public/index'
export default {
  data () {
    return {
      logo,
      menuList: [
        {
          name: '新着情報',
          route: '/'
        },
        {
          name: 'J-DIRECT-VPN',
          route: '/vpn'
        },
        {
          name: 'J-DIRECT-BOX',
          route: '/box'
        },
        {
          name: 'サポート',
          route: '/agent'
        },
        {
          name: '購入',
          route: '/buy'
        }
      ],
      activityMenu: 0
    }
  },
  watch: {
    $route (n, o) {

    }
  },
  created () {
    let isIn = this.menuList.findIndex(n => {
      return n.route === this.$route.path
    })
    if ((Number(isIn) + 1) !== 0) {
      this.activityMenu = isIn
    }
  },
  methods: {
    changeView (index) {
      this.activityMenu = index
      console.log(this.$route)
      if (this.$route.path === this.menuList[index].route) {
        return false
      }
      this.$router.push(this.menuList[index].route)
    }
  }
}
</script>
<style scoped>
.navbar {
  height: 70px;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 1100px;
  z-index: 999;
  box-shadow: 0px 0px 10px #999;
}
.navbar-inset {
  width: 1100px;
  margin: 0 auto;
  text-align: right;
}
.menu-list {
  margin-left: 100px;
  display: inline-flex;
  width: 600px;
  height: 70px;
  justify-content: space-between;
  vertical-align: top;
}
.menu {
  height: 70px;
  line-height: 70px;
  font-size: 15px;
  cursor: pointer;
}
.menu.activited {
  color: #01d0c0;
}
.logo {
  display: inline-block;
  width: 140px;
  margin-top: 20px;
  margin-right: 180px;
  vertical-align: top;
}
.logo img {
  width: 100%;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/public-modules/navbar/index.vue